import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import { notification } from "antd";

import { cancelSwmsApproverV2 } from "../../../../../actions/v2/JobSwmsTaskActions";
import { Strings } from "../../../../../dataProvider/localize";
import styles from "./SwmsDeleteConfirmModal.module.css";

const CancelIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" fill="currentColor" className={styles.infoBannerIcon}>
    <path d="M431.2 476.5L163.5 208.8C141.1 240.2 128 278.6 128 320C128 426 214 512 320 512C361.5 512 399.9 498.9 431.2 476.5zM476.5 431.2C498.9 399.8 512 361.4 512 320C512 214 426 128 320 128C278.5 128 240.1 141.1 208.8 163.5L476.5 431.2zM64 320C64 178.6 178.6 64 320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576C178.6 576 64 461.4 64 320z" />
  </svg>
);

const CloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" fill="currentColor" className={styles.closeBtnIcon}>
    <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3l105.4 105.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256l105.3-105.4z" />
  </svg>
);

export default function SwmsCancelApproverConfirmModal({ approver, jobId, swmsId, swmsName, swmsNumber, onClose, onSuccess }) {
  const dispatch = useDispatch();
  const [submitting, setSubmitting] = useState(false);

  const formName = swmsName || "SWMS";
  const formNumber = swmsNumber || "-";
  const approverName = approver && approver.name ? approver.name : "this approver";
  const approverEmail = approver && approver.email ? approver.email : "";

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget && !submitting) {
      onClose();
    }
  };

  const handleCancelApprover = () => {
    if (!approver || !approver.userId || !jobId || !swmsId) {
      notification.error({
        message: Strings.error_title,
        description: Strings.generic_error,
        className: "ant-error"
      });
      return;
    }

    setSubmitting(true);

    dispatch(cancelSwmsApproverV2(jobId, swmsId, {
      userId: approver.userId
    })).then((message) => {
      setSubmitting(false);
      notification.success({
        message: Strings.success_title,
        description: message || "Approval cancelled successfully.",
        className: "ant-success"
      });
      if (onSuccess) {
        onSuccess();
      }
      onClose();
    }).catch((err) => {
      setSubmitting(false);
      notification.error({
        message: Strings.error_title,
        description: err || Strings.generic_error,
        className: "ant-error"
      });
    });
  };

  return (
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <div className={styles.headerText}>
            <h3>Cancel Pending Approver</h3>
            <p className={styles.headerSubtitle}>{formName} · {formNumber}</p>
          </div>
          <button
            className={styles.closeBtn}
            onClick={onClose}
            disabled={submitting}
            type="button"
            aria-label="Close"
          >
            <CloseIcon />
          </button>
        </div>

        <div className={styles.body}>
          <div className={styles.infoBanner}>
            <CancelIcon />
            <span>
              Are you sure you want to cancel the approval request for {approverName}?
            </span>
          </div>
          <p className={styles.warningText}>
            The selected manager will no longer be able to approve this SWMS.
          </p>
          {/* {approverEmail ? (
            <p className={styles.reviewerMeta}>
              Approver email: <strong>{approverEmail}</strong>
            </p>
          ) : null} */}
        </div>

        <div className={styles.footer}>
          <button type="button" className={styles.cancelBtn} onClick={onClose} disabled={submitting}>
            Close
          </button>
          <button type="button" className={styles.deleteBtn} onClick={handleCancelApprover} disabled={submitting}>
            {submitting ? <CircularProgress size={16} style={{ color: "#fff" }} /> : "Cancel Approver"}
          </button>
        </div>
      </div>
    </div>
  );
}